import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppTopRightSide from './app/AppTopRightSide';
import AppBottomRightSide from './app/AppBottomRightSide';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <App />
  </>
);

const topRight = ReactDOM.createRoot(
  document.getElementById('top-right') as HTMLElement
);
topRight.render(
  <AppTopRightSide />
);

const bottomRight = ReactDOM.createRoot(
  document.getElementById('bottom-right') as HTMLElement
);
bottomRight.render(
  <AppBottomRightSide />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
